import Axios from "axios";
import request from "./request"

const createMiniappWechatPay = async (params) => {
    const resp = await request.post(`api/v1/payment/miniapp/wechatpay`, params);
    return resp.data;
  };
  
export default createMiniappWechatPay;